export default __webpack_public_path__ + "static/media/bg-dark.d2fe97db.png";